module.exports = __webpack_public_path__ + "media/images/varta/VARTA_Promotive_Blue_470x520-08064a84cf63bd387b103232ec6c090a.png";